var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "3" } },
            [_c("b-list-group", [_c("Menu")], 1)],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [_c("h4", [_vm._v(":: Test Drive")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "breadcrumb",
                              attrs: { cols: "12" }
                            },
                            [
                              _c("b-link", { attrs: { href: "/testdrives" } }, [
                                _vm._v("Test Drive")
                              ]),
                              _vm._v(" » "),
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href:
                                      "/testdrives/" + this.$route.params.brand
                                  }
                                },
                                [
                                  _vm._v(
                                    "Lista de participantes para " +
                                      _vm._s(this.$route.params.brand)
                                  )
                                ]
                              ),
                              _vm._v(
                                " » " +
                                  _vm._s(_vm.client.fullname) +
                                  ":\n                "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        { staticClass: "mb-4", on: { submit: _vm.onSubmit } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Nombre"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "fullname", state: _vm.state },
                                model: {
                                  value: _vm.client.fullname,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "fullname",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.fullname"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "DNI"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "dni", state: _vm.state },
                                model: {
                                  value: _vm.client.dni,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "dni",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.dni"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Teléfono"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "phone", state: _vm.state },
                                model: {
                                  value: _vm.client.phone,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "phone",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.phone"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Correo electrónico"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "email", state: _vm.state },
                                model: {
                                  value: _vm.client.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.email"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Tienda"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "store", state: _vm.state },
                                model: {
                                  value: _vm.client.store,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "store",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.store"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Marca"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "brand", state: _vm.state },
                                model: {
                                  value: _vm.client.brand,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "brand",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.brand"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Modelo de auto"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "model", state: _vm.state },
                                model: {
                                  value: _vm.client.model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.model"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "terms"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "terms", state: _vm.state },
                                model: {
                                  value: _vm.client.terms,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.client,
                                      "terms",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "client.terms"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary derco"
                              }
                            },
                            [_vm._v("Actualizar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c57eba4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c57eba4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditTestDrive.vue
// module id = null
// module chunks = 